module.exports = __webpack_public_path__ + "img/1.363d4914.jpg";